import React, { useEffect, useRef, useState } from "react";
import Pusher from "react-pusher";
import "./event-listing.scss";
import CountdownTimer from "../../components/CountdownTimer";
import Events from "../../components/Events/Events";
import { useDispatch, useSelector } from "react-redux";
import Attendees from "../../components/Events/Attendees";
import MeetingTable from "../../components/meeting-table/MeetingTable";
import { toast } from "react-toastify";
import { SiJitsi } from "react-icons/si";

// images
import AppleStore from "../../images/apple-store.png";
import GooglePlayStore from "../../images/google-playstore.png";
import MainContainer from "../../components/main-container/main-container.component";
import axios from "axios";
import clientConfig from "../../env";
import { updateBetaCredit } from "../../redux/user/user.actions";

function EventListing() {
  const meetingTableRef = useRef(null);
  const joinTableConfirmationRef = useRef(null);
  const joinTableConfirmationClosebtnRef = useRef(null);

  const dispatch = useDispatch();

  const token = useSelector((state) => state.user.token);
  const userCredit = useSelector((state) => state.user.mycredits);
  const userId = useSelector((state) => state.user.userId);
  const email_verified = useSelector((state) => state.user.email_verified);
  const currentEventDetail = useSelector(
    (state) => state.events.currentEventDetail
  );
  const isMasterTableEnable = useSelector(
    (state) => state.events.masterTableEnable
  );

  const isAllTableDisable = useSelector(
    (state) => state.events.allTableDisable
  );

  const [tableList, setTableList] = useState([]);
  const [eventTableUsers, setEventTableUsers] = useState([]);
  const [isLoadingTableList, setLoadingTableList] = useState(true);
  const [popupVisible, setPopupVisible] = useState(false);

  const [popupJoinTableNumber, setPopupJoinTableNumber] = useState(null);

  const callSchedulefromParent = () => {
    setPopupVisible(!popupVisible);
  };

  useEffect(() => {
    tableOrUserList();
    // getEventData();
  }, []);

  const handleJoinTableConfirmation = (data, event) => {
    console.log(event.target.alt);
    console.log(data);
    if (event.target.alt.indexOf("Table") === -1) return;
    if (data?.room_limit === data?.user_count) {
      toast.error("Room limit reached");
    } else {
      const userList = data?.user_list;
      const userFound =
        userList?.length && userList?.find((u) => u.id === userId);

      if (userFound) {
        toast.error("You already joined the table");
        return;
      }

      setPopupJoinTableNumber(data?.room_slug);
      joinTableConfirmationRef.current.click();
    }
  };

  const handleCloseTableConfirmation = () => {
    joinTableConfirmationClosebtnRef.current.click();
  };

  const handleJoinTable = () => {
    meetingTableRef.current.updateUserCreditDetails(popupJoinTableNumber);
  };

  function distributeUsersIntoGroups(users, roomLimit) {
    const numberOfGroups = 4;
    let distribution = [];

    if (roomLimit === 4) {
      distribution = [1, 1, 1, 1]; // Each group gets 1 user
    } else if (roomLimit === 6) {
      distribution = [2, 1, 2, 1]; // Groups 1 and 3 get 2 users, others get 1
    } else if (roomLimit === 8) {
      distribution = [3, 1, 3, 1]; // Groups 1 and 3 get 3 users, others get 1
    } else {
      const baseUsersPerGroup = Math.floor(roomLimit / numberOfGroups);
      const remainder = roomLimit % numberOfGroups;

      distribution = Array(numberOfGroups).fill(baseUsersPerGroup);

      for (let i = 0; i < remainder; i++) {
        distribution[i % 2 === 0 ? 0 : 2]++;
      }
    }

    const groups = [];
    let userIndex = 0;

    for (let groupIndex = 0; groupIndex < numberOfGroups; groupIndex++) {
      const userCount = distribution[groupIndex];
      const groupUsers = [];

      for (let i = 0; i < userCount && userIndex < users.length; i++) {
        groupUsers.push(users[userIndex]);
        userIndex++;
      }

      groups.push(groupUsers);
    }

    return groups;
  }

  const tableOrUserList = async (roomID) => {
    const configheader = {
      "Content-Type": `application/json`,
    };
    try {
      const response = await axios.get(
        `${clientConfig.siteUrl}wl/v1/rooms-users`,
        { headers: configheader }
      );

      const eventTableUsers = [];
      const otherTableUsers = [];
      response?.data?.forEach((table) => {
        const users = table?.users || [];
        if (table?.room_slug === "event_table") {
          eventTableUsers.push({
            id: table?.id,
            room_title: table?.room_title,
            room_slug: table?.room_slug,
            room_limit: table?.room_limit,
            user_count: users?.length || 0,
            user_list: users || [],
            users: distributeUsersIntoGroups(users, table?.room_limit) || [],
          });
        } else {
          otherTableUsers.push({
            id: table?.id,
            room_title: table?.room_title,
            room_slug: table?.room_slug,
            room_limit: table?.room_limit,
            user_count: users?.length || 0,
            user_list: users || [],
            users: distributeUsersIntoGroups(users, table?.room_limit) || [],
          });
        }
      });
      setTableList(otherTableUsers);
      setEventTableUsers(eventTableUsers);

      console.log({ eventTableUsers });

      // const tables = response?.data?.map((table) => {
      //   const users = table?.users || [];

      //   return {
      //     id: table?.id,
      //     room_title: table?.room_title,
      //     room_slug: table?.room_slug,
      //     room_limit: table?.room_limit,
      //     user_count: users?.length || 0,
      //     user_list: users || [],
      //     users: distributeUsersIntoGroups(users, table?.room_limit) || [],
      //   };
      // });
      // setTableList(tables);
      setLoadingTableList(false);
      // return tables;
      return otherTableUsers;
    } catch (e) {
      toast.error(
        e?.response?.data?.message ||
          "Something went wrong. Please try again later."
      );
      setLoadingTableList(false);
      return [];
    }
  };

  const handleAdd20CreditBeta = async () => {
    if (parseInt(userCredit) > 100) {
      toast.warning("Max credits reached for current plan.");
      return;
    }

    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Barer ${token}`,
      };
      const response = await axios.post(
        `${clientConfig.siteUrl}wl/v1/add-beta-credits`,
        {
          credit: 20,
          user_id: userId,
        },
        {
          headers,
        }
      );

      if (response.status === 200) {
        dispatch(updateBetaCredit(20));
        toast.success(response.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <MainContainer
      callSchedulefromParent={callSchedulefromParent}
      popupVisible={popupVisible}
    >
      <div className="row py-4 px-3">
        <div className="col-12 col-md-6">
          <h1 className="title mb-0">Events</h1>
        </div>
        <div className="col-12 col-md-6 text-md-right">
          <button className="btn btn-primary" disabled>
            New Event
          </button>
        </div>

        <div className="col-12">
          {/* Upcoming / Live Events */}
          <div className="p-3 border mt-4">
            <p className="font-weight-bold mb-3">Live / Upcoming</p>

            <div className="custom-table-event-list">
              <div className="head-row row">
                <div className="col-12 col-md-1 col-lg-2"></div>
                <div className="col-12 col-md-6 font-weight-bold">Event</div>
                <div className="col-12 col-md-2 font-weight-bold">
                  Time (EST)
                </div>
                <div className="col-12 col-md-2"></div>
              </div>

              <div className="body-row row">
                <div className="col-12 col-md-1 col-lg-2"></div>
                <div className="col-12 col-md-6">
                  <p className="mb-0">
                    <b>3For3 Networking</b>
                  </p>
                  <p className="mb-0">Join the Table</p>
                </div>
                <div className="col-12 col-md-2">
                  <p className="mb-0">Dec 15</p>
                  <p className="mb-0">2:00 PM</p>
                </div>
                <div className="col-12 col-md-2">
                  <button className="btn btn-link font-weight-bold p-0">
                    Register
                  </button>
                </div>
              </div>

              <div className="body-row row">
                <div className="col-12 col-md-1 col-lg-2"></div>
                <div className="col-12 col-md-6">
                  <p className="mb-0">
                    <b>3For3 Networking</b>
                  </p>
                  <p className="mb-0">Join the Table</p>
                </div>
                <div className="col-12 col-md-2">
                  <p className="mb-0">Jan 12</p>
                  <p className="mb-0">2:00 PM</p>
                </div>
                <div className="col-12 col-md-2">
                  <button className="btn btn-link font-weight-bold p-0">
                    Register
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Past Events */}
          <div className="p-3 border mt-4">
            <p className="font-weight-bold mb-3">Past</p>

            <div className="custom-table-event-list">
              <div className="head-row row">
                <div className="col-12 col-md-1 col-lg-2"></div>
                <div className="col-12 col-md-6 font-weight-bold">Event</div>
                <div className="col-12 col-md-2 font-weight-bold">
                  Time (EST)
                </div>
                <div className="col-12 col-md-2"></div>
              </div>

              <div className="body-row row">
                <div className="col-12 col-md-1 col-lg-2"></div>
                <div className="col-12 col-md-6">
                  <p className="mb-0">
                    <b>3For3 Networking</b>
                  </p>
                  <p className="mb-0">Join the Table</p>
                </div>
                <div className="col-12 col-md-2">
                  <p className="mb-0">Dec 08</p>
                  <p className="mb-0">2:00 PM</p>
                </div>
                <div className="col-12 col-md-2">
                  <button className="btn btn-link font-weight-bold p-0">
                    View
                  </button>
                </div>
              </div>

              <div className="body-row row">
                <div className="col-12 col-md-1 col-lg-2"></div>
                <div className="col-12 col-md-6">
                  <p className="mb-0">
                    <b>3For3 Networking</b>
                  </p>
                  <p className="mb-0">Join the Table</p>
                </div>
                <div className="col-12 col-md-2">
                  <p className="mb-0">Oct 20</p>
                  <p className="mb-0">2:00 PM</p>
                </div>
                <div className="col-12 col-md-2">
                  <button className="btn btn-link font-weight-bold p-0">
                    View
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center pb-5">
        <div className="row mb-5">
          <div className="col-12">
            <CountdownTimer />
            {currentEventDetail && <Attendees userId={userId} />}
          </div>
        </div>

        <Events />

        <div className="row mt-5">
          <div className="col-12">
            {isMasterTableEnable ? (
              <div className="mb-4">
                <h2 className="title">The Table</h2>

                <button
                  type="button"
                  className="btn btn-primary rounded-10 mt-2 px-5"
                  onClick={() =>
                    meetingTableRef.current.handleJoinTable("event_table")
                  }
                >
                  Join the Table
                </button>

                <div className="table-users-list mt-2">
                  {eventTableUsers[0]?.user_list?.length > 0 && (
                    <div className="d-flex align-items-center flex-column align-content-center w-100 mb-3">
                      <div className="d-flex">
                        {eventTableUsers[0]?.user_list.map(
                          (person, index) =>
                            index < 5 && (
                              <img
                                key={index}
                                src={person.avatar}
                                alt={person.name}
                                className="rounded-circle border border-dark bg-secondary"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  objectFit: "cover",
                                  marginLeft: index === 0 ? "0" : "-20px",
                                  zIndex: 10 + index,
                                }}
                              />
                            )
                        )}
                        {/* Circle with count + */}
                        {eventTableUsers[0]?.user_list.length > 5 ? (
                          <div
                            className="rounded-circle text-white d-flex justify-content-center align-items-center border border-dark"
                            style={{
                              width: "50px",
                              height: "50px",
                              marginLeft: "-20px",
                              fontSize: "18px",
                              zIndex: 15,
                              background: "#3762b4",
                            }}
                          >
                            {eventTableUsers[0]?.user_list.length - 5}+
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <h2 className="title">Join the Table</h2>
            )}
            {!email_verified ? (
              <div className="welcome-subtitle mb-0 text-danger">
                Verify your email to join.
              </div>
            ) : (
              <>
                <div className="welcome-subtitle mb-0">
                  <strong>10 credits</strong> to join.
                </div>
                <p className="mt-1 mb-0">
                  <span
                    className="btn p-0 btn-link"
                    onClick={handleAdd20CreditBeta}
                  >
                    Welcome to the beta. Get 20 free credits.
                  </span>
                </p>
              </>
            )}
          </div>

          {isLoadingTableList ? (
            <div className="col-12 text-center">Loading...</div>
          ) : (
            <>
              {!isLoadingTableList && (
                <Pusher
                  channel="meeting"
                  event="meeting_updates"
                  onUpdate={tableOrUserList}
                />
              )}

              {tableList.map((table, tableIndex) => (
                <MeetingTable
                  key={tableIndex}
                  tableIndex={tableIndex}
                  data={table}
                  isLoading={isLoadingTableList}
                  ref={meetingTableRef}
                  handleJoinTableConfirmation={handleJoinTableConfirmation}
                  handleCloseTableConfirmation={handleCloseTableConfirmation}
                  tableDisable={isAllTableDisable}
                />
              ))}
            </>
          )}
        </div>

        <div className="row mt-5" id="app_download_sec">
          <div className="col-12 col-lg-6 mx-auto">
            <p>
              <SiJitsi fontSize={"3em"} />
            </p>
            <p className="font-weight-bold" id="info">
              We use Jitsi for the ultimate web chat experience. Download the
              app.
            </p>

            <div className="row justify-content-center" id="logos">
              <div className="col-12 col-sm-6 col-md-4 col-lg-6 my-2 text-lg-right">
                <a
                  href="https://apps.apple.com/us/app/jitsi-meet/id1165103905"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={AppleStore}
                    alt="Apple store"
                    className="img-fluid"
                  />
                </a>
              </div>
              <div className="col-12 col-sm-6 col-md-4 col-lg-6 my-2 text-lg-left">
                <a
                  href="https://play.google.com/store/apps/details?id=org.jitsi.meet&pli=1"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={GooglePlayStore}
                    alt="Google play store"
                    className="img-fluid"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="jointablemodal"
          tabIndex="-1"
          aria-labelledby="jointablemodalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="jointablemodalLabel">
                  Join the Table
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  ref={joinTableConfirmationClosebtnRef}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <button
                  hidden={true}
                  ref={joinTableConfirmationRef}
                  data-toggle="modal"
                  data-target="#jointablemodal"
                ></button>
              </div>
              <div className="modal-body">
                <p className="m-0 text-left">
                  Confirm to join the table. <strong>10 credits</strong> to
                  join.
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary rounded-10"
                  onClick={handleJoinTable}
                >
                  Confirm
                </button>
                <button
                  id="jointableClosebtn"
                  type="button"
                  className="btn btn-secondary rounded-10"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainContainer>
  );
}

export default EventListing;
